/**
 * Blog reducer
 */

import { fromJS } from 'immutable'
import { RESET_DATA, SET_CONTENT } from './constants'
import { Reducer } from '../../types/common'

export const initialState = fromJS({
  someKey: 'This is a value in the reducer',
  title: '',
  content: []
})

const blogReducer: Reducer<any> = (state = initialState, action) => {
  switch (action.type) {
    case RESET_DATA:
      return initialState
    case SET_CONTENT:
      return state.set('content', fromJS(action.content))
    default:
      return state
  }
}

export default blogReducer



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Blog/reducer.ts